/**
 * i18n mínimo, escopado ao caminho que o App Review da Meta percorre
 * (login → integrações → conectar conta → dashboard Meta Ads).
 *
 * Por que não `next-intl`: ele exige middleware de rota e prefixo de locale na URL,
 * o que mexeria nas 121 páginas do app. Aqui o alvo são ~12 arquivos, e o custo certo
 * é um dicionário tipado + cookie. Quando a internacionalização virar objetivo de
 * produto (e não de submissão), este módulo é o ponto de troca.
 */
export const LOCALES = ["pt", "en"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "pt";

/** Nome do cookie lido no servidor e escrito pela Server Action `setLocale`. */
export const LOCALE_COOKIE = "mulply_locale";

export const isLocale = (value: unknown): value is Locale =>
    typeof value === "string" && (LOCALES as readonly string[]).includes(value);

/** `lang` do <html> — o que leitor de tela e tradutor automático consultam. */
export const HTML_LANG: Record<Locale, string> = {
    pt: "pt-br",
    en: "en",
};

/** Locale do `Intl` para número, moeda e data. */
export const INTL_LOCALE: Record<Locale, string> = {
    pt: "pt-BR",
    en: "en-US",
};
